module.exports = {
  props: ['index'],
  template: `<span>{{index}}</span>`
}